import * as React from "react";
const CallBlueIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6668 11.2827V13.2827C14.6675 13.4684 14.6295 13.6522 14.5551 13.8223C14.4807 13.9924 14.3716 14.1451 14.2348 14.2706C14.098 14.3962 13.9365 14.4917 13.7606 14.5512C13.5847 14.6107 13.3983 14.6328 13.2134 14.6161C11.162 14.3932 9.19141 13.6922 7.46007 12.5694C5.84928 11.5458 4.48361 10.1802 3.46005 8.56937C2.33336 6.83017 1.6322 4.85002 1.41337 2.78934C1.39671 2.60499 1.41862 2.41918 1.4777 2.24376C1.53679 2.06833 1.63175 1.90713 1.75655 1.77042C1.88135 1.63371 2.03324 1.52448 2.20257 1.44968C2.37189 1.37489 2.55494 1.33618 2.74004 1.336H4.74005C5.06359 1.33282 5.37725 1.44739 5.62257 1.65836C5.86788 1.86933 6.02811 2.1623 6.07339 2.48267C6.15781 3.12272 6.31436 3.75117 6.54006 4.35602C6.62976 4.59463 6.64917 4.85396 6.596 5.10327C6.54283 5.35259 6.4193 5.58143 6.24006 5.76269L5.39339 6.60936C6.34243 8.2784 7.72437 9.66034 9.39341 10.6094L10.2401 9.76271C10.4213 9.58347 10.6502 9.45994 10.8995 9.40677C11.1488 9.3536 11.4081 9.37301 11.6468 9.46271C12.2516 9.68841 12.8801 9.84496 13.5201 9.92938C13.8439 9.97507 14.1397 10.1382 14.3511 10.3877C14.5625 10.6372 14.6749 10.9558 14.6668 11.2827Z"
      stroke="#8b58f1"
      strokeWidth={1.33334}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CallBlueIcon;
